// extracted by mini-css-extract-plugin
export default {"indicator-bar":"_GsWOYR","indicator-bar__progress":"MdCUMTE","indicator-bar__triangle":"Q6qiuca"};